import React from 'react'
import { withEndUserData } from '@portal/kit/pkg/components'

import EditContainer from '../edit/edit-container'
import EditNameForm from './edit-name-form'
import userFullNameValidator from 'validators/user-full-name'

const EditNameView = ({ user }) => {
  const initialValues = {
    first_name: user.properties.first_name || user.properties.firstname,
    last_name: user.properties.last_name || user.properties.lastname
  }

  return (
    <EditContainer
      validator={userFullNameValidator}
      successMessage='account.name_updated'
      initialValues={initialValues}>
      { formProps => <EditNameForm {...formProps} />}
    </EditContainer>
  )
}

export default withEndUserData(EditNameView)
